"use client";
import React, { useState, useEffect } from "react";
import "@/components/common/Popup.css";
import { Constant, fontSizes } from "@/constants/constants";
import PopupImg from "@/assets/popup-women.webp"
import { createPortal } from "react-dom";
import { FaClosedCaptioning, FaCross } from "react-icons/fa6";
import Image from "next/image";
import { Form, Input } from "antd";import "./animated-button.css";
import { FaArrowRight } from "react-icons/fa";
import { submitLeadForm } from "@/lib/submit-form";
const AnimatedButton = ({ className = "btnPrimary openPopup", Text = "Request A Quote", onClick, auto = false  }) => {
    const [isScrolled, setIsScrolled] = useState(false);
      const [mounted, setMounted] = useState(false);
    
      useEffect(() => {
        setMounted(true); // for portal
        function handleScroll() {
          const scrollTop = window.pageYOffset;
          setIsScrolled(scrollTop > 500);
        }
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
      }, []);
    
      const [popupOpen, setPopupOpen] = useState(false);
    
      const closePopup = () => setPopupOpen(false);
      const openPopup = () => setPopupOpen(true);
    
      useEffect(() => {
        if (auto) {
          const timer = setTimeout(() => {
            openPopup();
          }, 5000);
          return () => clearTimeout(timer);
        }
      }, [auto]);
    
      const [submitting, setSubmitting] = useState(false);

      const onFinish = async (values) => {
        if (submitting) return;
        setSubmitting(true);
        const res = await submitLeadForm(values, "Animated Button — Request A Quote");
        setSubmitting(false);
        if (res.ok) {
          window.location.replace("/thankyou");
        } else {
          alert(res.message);
        }
      };
  return (
    <>
            {/* Popup rendered in portal */}
            {mounted && popupOpen &&
              createPortal(
                <div onClick={closePopup} className="fixed  inset-0 z-[9999] flex justify-center items-center bg-black/50 backdrop-blur-sm">
                  <div     onClick={(e) => e.stopPropagation()} // 👈 prevent closing when clicking inside
       className="relative bg-[#fff] flex flex-col md:flex-row justify-between bg-white rounded-xl shadow-xl max-w-[1440px] w-full p-6">
                    
                    {/* Text/Form Side */}
                    <div className="md:w-1/2 p-3 md:p-8 space-y-4">
                      <h2 className={`text-black ${fontSizes.text_3_xl} font-bold`}>
                        50% Discount
                      </h2>
                      <h3 className={`text-[#1EA7DB] ${fontSizes.text_2_xl} font-bold`}>
                        Your Bestselling book is just a click away
                      </h3>
                      <p className={`text-[#1EA7DB] ${fontSizes.base}`}>
                        Let’s schedule a call and attain free consultancy.
                      </p>
      
                      <Form
                        name="normal_login"
                        initialValues={{ remember: true }}
                        onFinish={onFinish}
                      >
                        <Form.Item
                          name="name"
                          rules={[{ required: true, message: "Please input your Name!" }]}
                        >
                          <Input
                            type="text"
                            placeholder="Enter Your Full Name*"
                            className="w-full p-3 border border-[#000] rounded"
                          />
                        </Form.Item>
      
                        <Form.Item
                          name="email"
                          rules={[
                            { type: "email", message: "The input is not valid E-mail!" },
                            { required: true, message: "Please input your E-mail!" },
                          ]}
                        >
                          <Input
                            type="email"
                            placeholder="Enter Your Email Address*"
                            className="w-full p-3 border border-gray-300 rounded"
                          />
                        </Form.Item>
      
                        <Form.Item
                          name="phone"
                          rules={[{ required: true, message: "Please input your Phone!" }]}
                        >
                          <Input
                            type="tel"
                            placeholder="Enter Your Phone No*"
                            className="w-full p-3 border border-gray-300 rounded"
                          />
                        </Form.Item>
      
                        <Form.Item
                          name="message"
                          rules={[{ required: true, message: "Please input your message" }]}
                        >
                          <Input.TextArea
                            placeholder="To help us understand better, enter a brief description about your book."
                            className="w-full p-3 border border-gray-300 rounded"
                            rows={4}
                          />
                        </Form.Item>
      
                        <button
                          type="submit"
                          disabled={submitting}
                          className="bg-[#1EA7DB] text-white p-3 px-10 rounded-3xl hover:bg-blue-900 transition text-[#fff] font-semibold disabled:opacity-60"
                        >
                          {submitting ? "Sending..." : "Submit"}
                        </button>
                      </Form>
                    </div>
      
                    {/* Image Side */}
                    <div className="md:w-1/2 flex justify-center items-end relative">
                      <Image
                        src={PopupImg}
                        alt="Girl holding books"
                        className="w-full max-w-sm md:max-w-lg h-auto object-contain"
                      />
                    </div>
      
                    {/* Close Button */}
                    <button
                      onClick={closePopup}
                      className="absolute top-4 right-4 text-2xl border-2 border-black rounded-full px-2 text-black"
                    >
                      &times;
                    </button>
                  </div>
                </div>,
                document.body
              )
            }
      
    <button type="button" className={className} data-aos="fade-right"
        onClick={openPopup}>
      <span>
        {Text} <FaArrowRight />
      </span>
    </button>
    </>
  );
};

export default AnimatedButton;
